import Vue from 'vue'
import Router from 'vue-router'
import News from "@/components/News"
import Home from "@/components/Home"
import HelloWorld from '@/components/HelloWorld'
import {Session} from '@/utils/storage';


Vue.use(Router)


function isWechat() {
  let ua = window.navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {

    return true;

  } else {

    return false;

  }
}

let router = new Router({
    routes: [
      {
        path: '/',
        name: 'HelloWorld',
        redirect: '/home',
        component: HelloWorld
      },
      {
        path: '/login',
        name: 'login',
        component: () => import('@/views/login/login'),
        meta: {title: '欢迎', icon: 'dashboard'}
      },
      {
        path: '/register',
        name: 'register',
        component: () => import('@/views/login/register'),
        meta: {title: '欢迎', icon: 'dashboard'}
      },
      {
        path: '/forgetwoed',
        name: 'forgetwoed',
        component: () => import('@/views/login/forgetwoed'),
        meta: {title: '欢迎', icon: 'dashboard'}
      },
      {
        path: '/forgetNext',
        name: 'forgetNext',
        component: () => import('@/views/login/forgetNext'),
        meta: {title: '欢迎', icon: 'dashboard'}
      },
      {
        path: '/nomatch',
        name: 'nomatch',
        component: () => import('@/views/error/nomath.vue'),
        meta: {
          title: '没有此比赛',
        },
      },
      {
        path: '/norightWeb',
        name: 'norightWeb',
        component: () => import('@/views/error/norightWeb.vue'),
        meta: {
          title: '请用正确浏览器打开',
        },
      },
      {
        path: '/',
        name: 'HelloWorld',
        component: HelloWorld,
        children: [{
          path: 'news',
          name: 'news',
          component: News,
          meta: {title: '欢迎', icon: 'dashboard'}
        },
          // {
          //   path: '/login',
          //   name: 'login',
          //   component: () => import('@/views/login/login'),
          //   meta: { title: '欢迎', icon: 'dashboard' }
          // },
          // {
          //   path: '/register',
          //   name: 'register',
          //   component: () => import('@/views/login/register'),
          //   meta: { title: '欢迎', icon: 'dashboard' }
          // },
          {
            path: 'home',
            name: 'home',
            component: Home,
            meta: {title: 'home', icon: 'dashboard'}
          },
          {
            path: 'uplading',
            name: 'uplading',
            component: () => import('@/views/user/uploading'),
            meta: {title: 'home', icon: 'dashboard'}
          },
          {
            path: 'upladingpro',
            name: 'upladingpro',
            component: () => import('@/views/user/uploadingpro'),
            meta: {title: 'home', icon: 'dashboard'}
          },
          {
            path: 'info',
            name: 'info',
            component: () => import('@/views/user/info'),
            meta: {title: 'home', icon: 'dashboard'}
          },
          {
            path: 'infopro',
            name: 'infopro',
            component: () => import('@/views/user/infopro'),
            meta: {title: 'home', icon: 'dashboard'}
          },
          {
            path: 'NewsMore',
            name: 'NewsMore',
            component: () => import('@/views/News/NewsMore'),
            meta: {title: 'home', icon: 'dashboard'}
          },
          {
            path: 'introduced',
            name: 'introduced',
            component: () => import('@/views/match/index'),
            meta: {title: 'home', icon: 'dashboard'}
          },
          {
            path: 'SchoolMore',
            name: 'SchoolMore',
            component: () => import('@/views/News/SchoolMore'),
            meta: {title: 'home', icon: 'dashboard'}
          },
          {
            path: 'notice',
            name: 'notice',
            component: () => import('@/views/Notice/notice'),
            meta: {title: 'home', icon: 'dashboard'}
          },
          {
            path: 'noticInfo',
            name: 'noticInfo',
            component: () => import('@/views/Notice/info'),
            meta: {title: 'home', icon: 'dashboard'}
          },
          {
            path: 'newsInfo',
            name: 'newsInfo',
            component: () => import('@/views/News/info'),
            meta: {title: 'home', icon: 'dashboard'}
          },
          {
            path: 'myWork',
            name: 'myWork',
            component: () => import('@/views/user/myWork'),
            meta: {title: 'myWork', icon: 'dashboard'}
          },
          {
            path: 'upyne',
            name: 'upyne',
            component: () => import('@/views/user/duandian'),
            meta: {title: 'home', icon: 'dashboard'}
          },
          {
            path: 'evaluation',
            name: 'evaluation',
            component: () => import('@/views/user/evaluation'),
            meta: {title: 'home', icon: 'dashboard'}
          },
          {
            path: 'worksInfo',
            name: 'worksInfo',
            component: () => import('@/views/works/info'),
            meta: {title: 'home', icon: 'dashboard'}
          },
          {
            path: 'more',
            name: 'more',
            component: () => import('@/views/works/more'),
            meta: {title: 'home', icon: 'dashboard'}
          },
          {
            path: 'draw',
            name: 'draw',
            component: () => import('@/views/match/draw'),
            meta: {title: 'home', icon: 'dashboard'}
          }
        ]
      }
    ]
  }
)

// 路由加载前
router.beforeEach((to, from, next) => {

  // console.log('toooooo',to);
  // console.log('tpssad0',isWechat );
  let token = Session.get('token');
  if (!isWechat() && to.path === '/norightWeb') {
    next('/home');
  }
  if (to.path === '/myWork') {
    if (token) {
      next();

    } else {
      next('/home');

    }
  } else {
    next();

  }
  // if (to.path === '/home' || to.path === '/nomatch' && !token) {
  // 	next();
  // 	delayNProgressDone();
  // } else {
  // 	if (!token) {
  // 		// NProgress.start();
  // 		next('/home');
  // 		Session.clear();
  // 		// delayNProgressDone();
  // 	} else {
  // 		// 动态加载后端返回路由路由(模拟数据) //
  // 		if (!getSession('userInfo')) return false;
  // 		if (Object.keys(store.state.routesList.routesList).length <= 0) {
  // 			 adminUser(router, to, next);
  // 			//  console.log('初始化菜单')
  // 		} else {
  // 			 console.log('跳转',to)
  // 			next();
  // 			delayNProgressDone(0);
  // 		}
  // 	}
  // }
});
export default router



// WEBPACK FOOTER //
// ./src/router/index.js